export default __webpack_public_path__ + "static/media/14.2d31d5a9.png";